// @generated by protoc-gen-es v2.2.3 with parameter "target=ts"
// @generated from file ProcedureLeg.proto (package ProcedureLeg, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import type { ProcedureCoordPoints } from "./ProcedureCoordPoints_pb";
import { file_ProcedureCoordPoints } from "./ProcedureCoordPoints_pb";
import type { Procedure } from "./Procedure_pb";
import { file_Procedure } from "./Procedure_pb";
import type { CurvePoint } from "./CurvePoint_pb";
import { file_CurvePoint } from "./CurvePoint_pb";
import { file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file ProcedureLeg.proto.
 */
export const file_ProcedureLeg: GenFile = /*@__PURE__*/
  fileDesc("ChJQcm9jZWR1cmVMZWcucHJvdG8SDFByb2NlZHVyZUxlZyKNBgoMUHJvY2VkdXJlTGVnEj4KCnN0YXJ0UG9pbnQYASABKAsyKi5Qcm9jZWR1cmVDb29yZFBvaW50cy5Qcm9jZWR1cmVDb29yZFBvaW50cxI8CghlbmRQb2ludBgCIAEoCzIqLlByb2NlZHVyZUNvb3JkUG9pbnRzLlByb2NlZHVyZUNvb3JkUG9pbnRzEjwKCGZpeFBvaW50GAMgASgLMiouUHJvY2VkdXJlQ29vcmRQb2ludHMuUHJvY2VkdXJlQ29vcmRQb2ludHMSJwoJcHJvY2VkdXJlGAQgASgLMhQuUHJvY2VkdXJlLlByb2NlZHVyZRIrCgtjdXJ2ZVBvaW50cxgFIAMoCzIWLkN1cnZlUG9pbnQuQ3VydmVQb2ludBIvCglhcmNsZW5ndGgYBiABKAsyHC5nb29nbGUucHJvdG9idWYuRG91YmxlVmFsdWUSLwoKZW5kUG9pbnRJZBgHIAEoCzIbLmdvb2dsZS5wcm90b2J1Zi5JbnQzMlZhbHVlEi8KCmZpeFBvaW50SWQYCCABKAsyGy5nb29nbGUucHJvdG9idWYuSW50MzJWYWx1ZRInCgJpZBgJIAEoCzIbLmdvb2dsZS5wcm90b2J1Zi5JbnQzMlZhbHVlEjEKDWlzc3RyYWlnaHRsZWcYCiABKAsyGi5nb29nbGUucHJvdG9idWYuQm9vbFZhbHVlEjQKDnByb2NlZHVyZWxlZ2lkGAsgASgLMhwuZ29vZ2xlLnByb3RvYnVmLlN0cmluZ1ZhbHVlEjAKC3Byb2NlZHVyZVBrGAwgASgLMhsuZ29vZ2xlLnByb3RvYnVmLkludDMyVmFsdWUSLAoGcmFkaXVzGA0gASgLMhwuZ29vZ2xlLnByb3RvYnVmLkRvdWJsZVZhbHVlEjMKDnNlcXVlbmNlbnVtYmVyGA4gASgLMhsuZ29vZ2xlLnByb3RvYnVmLkludDMyVmFsdWUSMQoMc3RhcnRQb2ludElkGA8gASgLMhsuZ29vZ2xlLnByb3RvYnVmLkludDMyVmFsdWVCQgotY29tLmdtdi5kZW1ldGVyLm5hdmFpZHMubW9kZWwucHJvdG8uZ2VuZXJhdGVkQhFQcm9jZWR1cmVMZWdQcm90b2IGcHJvdG8z", [file_ProcedureCoordPoints, file_Procedure, file_CurvePoint, file_google_protobuf_wrappers]);

/**
 * @generated from message ProcedureLeg.ProcedureLeg
 */
export type ProcedureLeg = Message<"ProcedureLeg.ProcedureLeg"> & {
  /**
   * @generated from field: ProcedureCoordPoints.ProcedureCoordPoints startPoint = 1;
   */
  startPoint?: ProcedureCoordPoints;

  /**
   * @generated from field: ProcedureCoordPoints.ProcedureCoordPoints endPoint = 2;
   */
  endPoint?: ProcedureCoordPoints;

  /**
   * @generated from field: ProcedureCoordPoints.ProcedureCoordPoints fixPoint = 3;
   */
  fixPoint?: ProcedureCoordPoints;

  /**
   * @generated from field: Procedure.Procedure procedure = 4;
   */
  procedure?: Procedure;

  /**
   * @generated from field: repeated CurvePoint.CurvePoint curvePoints = 5;
   */
  curvePoints: CurvePoint[];

  /**
   * @generated from field: google.protobuf.DoubleValue arclength = 6;
   */
  arclength?: number;

  /**
   * @generated from field: google.protobuf.Int32Value endPointId = 7;
   */
  endPointId?: number;

  /**
   * @generated from field: google.protobuf.Int32Value fixPointId = 8;
   */
  fixPointId?: number;

  /**
   * @generated from field: google.protobuf.Int32Value id = 9;
   */
  id?: number;

  /**
   * @generated from field: google.protobuf.BoolValue isstraightleg = 10;
   */
  isstraightleg?: boolean;

  /**
   * @generated from field: google.protobuf.StringValue procedurelegid = 11;
   */
  procedurelegid?: string;

  /**
   * @generated from field: google.protobuf.Int32Value procedurePk = 12;
   */
  procedurePk?: number;

  /**
   * @generated from field: google.protobuf.DoubleValue radius = 13;
   */
  radius?: number;

  /**
   * @generated from field: google.protobuf.Int32Value sequencenumber = 14;
   */
  sequencenumber?: number;

  /**
   * @generated from field: google.protobuf.Int32Value startPointId = 15;
   */
  startPointId?: number;
};

/**
 * Describes the message ProcedureLeg.ProcedureLeg.
 * Use `create(ProcedureLegSchema)` to create a new message.
 */
export const ProcedureLegSchema: GenMessage<ProcedureLeg> = /*@__PURE__*/
  messageDesc(file_ProcedureLeg, 0);

